module.exports = __webpack_public_path__ + "static/media/lvl-group-6.0f1adf40.png";